import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { HttpClient } from '../configs/axios.config';
import { CardModel, EvaluationMark, PreloadBufferItem, TopicModel } from '../interfaces/models/CardModel';
import { Api } from './Api';

@injectable()
export class CardApi implements Api {

    constructor(
        public api: HttpClient
    ) {}

    getCardById(cardId): AxiosPromise<CardModel> {
        return this.api.client.get<CardModel>(`/card/id/?cardId=${cardId}`);
    }

    getCard(courseId): AxiosPromise<CardModel> {
        return this.api.client.get<CardModel>(`/card/next/?course=${courseId}`);
    }

    getPreload(courseId): AxiosPromise<PreloadBufferItem> {
        return this.api.client.get<PreloadBufferItem>(`/card/preload/?course=${courseId}`);
    }

    getTopic(id): AxiosPromise<TopicModel> {
        return this.api.client.get(`/card/topic?id=${id}`);
    }

    back(courseId: number) {
        return this.api.client.get(`/card/back/?course=${courseId}`);
    }

    skip(id: number, nextId: number) {
        return this.api.client.post(`/card/skip/`, { id, next_id: nextId });
    }

    evaluate(id: number, nextId: number, mark: EvaluationMark, update = false, log = '') {
        return this.api.client.post(`/card/evaluate/`, {
            id, next_id: nextId, update, mark, log, time_spent: 0
        })
    }

    answerGrammarCard(id: number, log: string, mark: EvaluationMark) {
        return this.api.client.post(`/card/grammaranswer/`, {
            id, log, mark, time_spent: 0
        })
    }

}
